import { render, staticRenderFns } from "./ArchiveVideoRect.vue?vue&type=template&id=92200b22&scoped=true&lang=pug&"
import script from "./ArchiveVideoRect.vue?vue&type=script&lang=js&"
export * from "./ArchiveVideoRect.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveVideoRect.scss?vue&type=style&index=0&id=92200b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92200b22",
  null
  
)

export default component.exports